import { ChangeDetectionStrategy, Component, OnInit, computed, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { SelectItemField } from 'lib/ui/form/fields/select-item-field.component.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
	selector: 'mod-new-client',
	templateUrl: './new-client.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NewClientComponent extends TypeCoreComponent implements OnInit {
	public readonly form = {
		email: signal<string | undefined>(undefined),
		password: signal<string | undefined>(undefined),
		firstName: signal<string | undefined>(undefined),
		lastName: signal<string | undefined>(undefined),
		weightKg: signal<number | undefined>(undefined),
		heightCm: signal<number | undefined>(undefined),
		preferredUnit: signal<UserDb.MeasurementUnitType>('metric'),
		gender: signal<UserDb.UserGender | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const password = this.form.password();
		const email = this.form.email();

		if (!email || !password) {
			return undefined;
		}

		const formData: UserApi.INewClientRequest = {
			email: email,
			password: password,
			firstName: this.form.firstName(),
			lastName: this.form.lastName(),
			weightKg: this.form.weightKg(),
			heightCm: this.form.heightCm(),
			preferredUnit: this.form.preferredUnit(),
			gender: this.form.gender()
		};

		return this.dependencies.httpService
			.post<UserDb.IUserItem, UserApi.INewClientRequest>((builder) =>
				builder.withCustomApiRoute('user', 'newClient').withData(formData).build()
			)
			.pipe(
				map((response) => {
					super.notifyCreated('Client');
					this.dependencies.navigateService
						.actionRoute((routes) => routes.trainerClientRoutes.client.children.view, response.data.id)
						.navigate();
				})
			);
	});

	public readonly preferredUnitSelectItems: SelectItemField<UserDb.MeasurementUnitType>[] = [
		{
			title: 'Imperial',
			value: 'imperial',
			data: 'imperial'
		},
		{
			title: 'Metric',
			value: 'metric',
			data: 'metric'
		}
	];

	public readonly genderSelectItems: readonly SelectItemField<UserDb.UserGender>[] = [
		{
			title: 'Male',
			value: 'male',
			data: 'male'
		},
		{
			title: 'Female',
			value: 'female',
			data: 'female'
		}
	];

	constructor() {
		super();
	}
}
